"use client";

import { ArrowUpRight, Blocks, BrainCircuit, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
export default function TechnicalDuctEngineering() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pillars = [{
    number: "01",
    title: "RIQUALIFICAZIONE TECNICA",
    icon: Blocks,
    description: "Adottiamo protocolli avanzati di bonifica tecnica per ripristinare l'efficienza originale degli impianti. Ogni intervento è progettato per eliminare depositi e contaminanti, garantendo la massima salubrità dell'aria e il corretto funzionamento dei flussi in ogni condotto."
  }, {
    number: "02",
    title: "ANALISI E METODO",
    icon: BrainCircuit,
    description: "La nostra metodologia si fonda su un'analisi critica rigorosa. Dall'ispezione visiva alla verifica finale, ogni fase è documentata per garantire la conformità normativa e l'ottimizzazione delle prestazioni energetiche del sistema HVAC e di estrazione."
  }, {
    number: "03",
    title: "SICUREZZA CERTIFICATA",
    icon: Lock,
    description: "Interventi eseguiti in totale sicurezza con strumentazione all'avanguardia. Utilizziamo robot di ispezione, spazzole rotanti e sistemi di filtrazione HEPA per operare in ambienti sensibili, garantendo discrezione, protezione degli asset e reportistica fotografica dettagliata."
  }];
  return <section data-section-id="5200" id="technicalductengineering" className="bg-background text-foreground py-32 md:py-50 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16 md:mb-24 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-3">
              <span className="font-default text-xs md:text-sm tracking-widest uppercase text-secondary">
                02 / IL METODO AERA SANUM
              </span>
              <div className="h-px w-16 bg-accent" />
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-default font-black text-4xl sm:text-5xl md:text-6xl lg:text-[88px] leading-[0.95] tracking-tight uppercase text-secondary">
              TRE /
              <br />
              PILASTRI TECNICI.
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <PillarCard key={i} pillar={pillar} Icon={Icon} index={i} />;
        })}
        </div>
      </div>
    </section>;
}
function PillarCard({
  pillar,
  Icon,
  index
}: {
  pillar: {
    number: string;
    title: string;
    description: string;
  };
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={index} style={{
    transitionDelay: `${index * 100}ms`
  }} className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <Card className="group relative h-full min-h-[480px] bg-card backdrop-blur-sm border border-border rounded-lg p-10 md:p-12 flex flex-col shadow-lg hover:border-accent hover:shadow-xl transition-all duration-500">
        {}
        <div className="font-default text-5xl md:text-6xl font-light text-secondary transition-transform duration-500 group-hover:scale-110 origin-left">
          {pillar.number}
        </div>

        {}
        <div className="h-px w-full bg-accent/40 mt-6 mb-10 group-hover:bg-accent transition-colors duration-500" />

        {}
        <Icon className="size-8 text-accent group-hover:text-accent transition-colors duration-500 mb-8" strokeWidth={1} />

        {}
        <h3 className="font-default font-bold text-2xl md:text-3xl uppercase tracking-tight mb-6 leading-tight text-secondary">
          {pillar.title}
        </h3>

        {}
        <p className="font-default text-base md:text-[17px] leading-relaxed text-muted-foreground mb-10 flex-grow">
          {pillar.description}
        </p>

        {}
        <div className="mt-auto">
          <Button variant="ghost" size="sm" className="font-default text-xs tracking-widest uppercase text-foreground hover:text-accent hover:bg-transparent p-0 h-auto group/btn">
            DETTAGLI INTERVENTO
            <ArrowUpRight className="size-4 text-accent transition-transform duration-300 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
          </Button>
        </div>
      </Card>
    </div>;
}